import { ReactComponent as NotFoundImage } from 'assets/icons/not-found.svg';

export default NotFoundImage;
